<script>
  export let date;
  export let location = "";
  export let latitude = 0;
  export let longitude = 0;
</script>

<h1>Fish-Dash { location }</h1>

<style>
  h1 {
    font-family: 'Oswald', sans-serif;
    font-size: 100px;
    text-transform: uppercase;
  }
</style>